export default __webpack_public_path__ + "static/media/robot1.67f70f99.jpg";